import { useTaskBonusTotals } from "./useTaskBonusTotals.js";
import {
  resetSessionResources,
  getSessionCacheIdentity,
} from "../shared/sessionCache.js";
import { addRankingPoints } from "./useTaskBonusTotals.js";
import { globalCacheRef } from "./usePageData.js";
import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { useAppNavigation } from "../routes/config";
import { useAuth } from "./useAuth";
import { useAllCheckpoints } from "./useAllCheckpoints";
import { usePageData } from "./usePageData";
import {
  loadConteudosData,
  normalizeConteudosData,
  persistConteudosData,
} from "../data";
import {
  createConteudoCategoria,
  createConteudoAula,
  createConteudoCurso,
  createConteudoModulo,
  deleteConteudoCategoria,
  deleteConteudoAula,
  deleteConteudoCurso,
  deleteConteudoModulo,
  fetchConteudoCategorias,
  fetchConteudosAluno,
  fetchConteudosState,
  restoreConteudoCategoria,
  restoreConteudoCurso,
  restoreConteudoModulo,
  restoreConteudoAula,
  saveConteudosErrors,
  saveConteudosProgress,
  saveConteudosStructure,
  updateConteudoAula,
  updateConteudoCategoria,
  updateConteudoCurso,
  updateConteudoModulo,
} from "../services/conteudosApi";
import { useSimuladoresConteudoState } from "./useSimuladoresConteudoState";
import { useOlimpiadaConteudoState } from "./useOlimpiadaConteudoState";
import { todayISO } from "../shared/utils";
const serialize = (value) => JSON.stringify(value ?? null);
const pickConteudosStructure = (value) => ({
  categorias: value?.categorias || [],
  cursos: value?.cursos || [],
  modulos: value?.modulos || [],
  aulas: value?.aulas || [],
});
const EMPTY_CONTEUDOS = normalizeConteudosData({
  categorias: [],
  cursos: [],
  modulos: [],
  aulas: [],
  erros: [],
  progresso: {},
});
export function useAppShellState() {
  const useAppNavigationResult = useAppNavigation();
  const view = useAppNavigationResult.view;
  const canGoBack = useAppNavigationResult.canGoBack;
  const gotoView = useAppNavigationResult.gotoView;
  const goBackView = useAppNavigationResult.goBackView;
  const useAuthResult = useAuth();
  const authStudent = useAuthResult.student;
  const adminLogged = useAuthResult.adminLogged;
  const setAdminLogged = useAuthResult.setAdminLogged;
  const authLoading = useAuthResult.loading;
  const authError = useAuthResult.error;
  const setAuthError = useAuthResult.setError;
  const loginAluno = useAuthResult.loginAluno;
  const loginAdmin = useAuthResult.loginAdmin;
  const authLogout = useAuthResult.logout;
  const isAuthenticated = Boolean(authStudent || adminLogged);
  const taskBonusTotals = useTaskBonusTotals(
    isAuthenticated,
    null,
    null,
    null,
    (msg) =>
      setFlash({
        msg,
        tipo: "er",
      }),
  );
  const [studentId, setStudentId] = useState(authStudent?.id ?? null);
  const [viewingStudent, setViewingStudent] = useState(null);
  const [editingProfile, setEditingProfile] = useState(false);
  const [editingStudent, setEditingStudent] = useState(null);
  const [editingHouse, setEditingHouse] = useState(null);
  const [editingTeacher, setEditingTeacher] = useState(null);
  const [editingActivity, setEditingActivity] = useState(null);
  const [editingGrupoAcesso, setEditingGrupoAcesso] = useState(null);
  const [pageResetKeys, setPageResetKeys] = useState({});
  const [houses, setHouses] = useState([]);
  const [gruposAcesso, setGruposAcesso] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [activities, setActivities] = useState([]);
  const [students, setStudents] = useState([]);
  const [checkpoints, setCheckpoints] = useState([]);
  const [redemptions, setRedemptions] = useState([]);
  const [bonusLog, setBonusLog] = useState([]);
  const [batalhas, setBatalhas] = useState([]);
  const [transfers, setTransfers] = useState([]);
  const [salas, setSalas] = useState([]);
  const [agendamentos, setAgendamentos] = useState([]);
  const [bloqueios, setBloqueios] = useState([]);
  const [cardapio, setCardapio] = useState([]);
  const [meritos, setMeritos] = useState([]);
  const initialConteudos = useMemo(() => loadConteudosData(), []);
  const [conteudos, setConteudosRaw] = useState(EMPTY_CONTEUDOS);
  const [conteudosNavigationTarget, setConteudosNavigationTarget] =
    useState(null);
  const [flash, setFlash] = useState(null);
  const [adminAba, setAdminAba] = useState("relatorio");
  const [sideOpen, setSideOpen] = useState(
    () => window.matchMedia("(min-width:1341px)").matches,
  );
  const conteudosLoadedRef = useRef(false);
  const conteudosApiInitializedRef = useRef(false);
  const conteudosBootstrapRef = useRef(false);
  const skipConteudosSyncRef = useRef(true);
  const conteudosSyncTimerRef = useRef(null);
  const conteudosEnterRefreshRef = useRef("");
  const previousConteudosRef = useRef(EMPTY_CONTEUDOS);
  const loadAlunoSnapshot =
    (useCallback(async () => {
      const [conteudosStateResult, categoriasResult] = await Promise.allSettled(
        [fetchConteudosState(), fetchConteudoCategorias()],
      );
      if ("fulfilled" !== conteudosStateResult.status)
        throw new Error("Falha ao carregar snapshot de conteúdos");
      const resultado = conteudosStateResult.value;
      const initialized = resultado.initialized;
      const snapshot = resultado.snapshot;
      const categoriasApi =
        "fulfilled" === categoriasResult.status &&
        Array.isArray(categoriasResult.value)
          ? categoriasResult.value
          : [];
      return {
        initialized,
        nextSnapshot: {
          ...snapshot,
          categorias: categoriasApi.length
            ? categoriasApi
            : snapshot?.categorias || [],
        },
      };
    }, []),
    useCallback(async () => {
      const responseInitialized = await fetchConteudosAluno();
      return {
        initialized: responseInitialized.initialized,
        nextSnapshot: responseInitialized.snapshot,
      };
    }, []));
  const resourceScope = useRef(null);
  const resourceReset = resetSessionResources(
    resourceScope,
    getSessionCacheIdentity(authStudent?.casa_id),
    [
      setHouses,
      setGruposAcesso,
      setTeachers,
      setActivities,
      setStudents,
      setCheckpoints,
      setRedemptions,
      setBonusLog,
      setBatalhas,
      setTransfers,
      setSalas,
      setAgendamentos,
      setBloqueios,
      setCardapio,
      setMeritos,
    ],
  );
  const response = usePageData(
    view,
    adminAba,
    isAuthenticated,
    authStudent?.casa_id,
  );
  const pageData = response.data;
  const pageLoading = response.loading;
  const checkpointsComAutomaticos = useAllCheckpoints(
    checkpoints,
    Boolean(authStudent || adminLogged),
    true,
    authStudent?.casa_id,
  ).checkpoints;
  const checkpointsCompletos = useMemo(
    () =>
      checkpointsComAutomaticos.filter(
        (checkpointsComAutomatico) =>
          !((resultado) => {
            const resultadoAtual2 = resultado?.observacao;
            return (
              "string" === typeof resultadoAtual2 &&
              "tempo estudado automático (contador do site)" ===
                resultadoAtual2.trim().toLowerCase()
            );
          })(checkpointsComAutomatico),
      ),
    [checkpointsComAutomaticos],
  );
  useEffect(() => {
    const matchMediaResult = window.matchMedia("(min-width:1341px)");
    const change = (resultado) => setSideOpen(resultado.matches);
    matchMediaResult.addEventListener("change", change);
    const esc = (resultado) => {
      if (resultado.key === "Escape") setSideOpen(false);
    };
    window.addEventListener("keydown", esc);
    return () => {
      matchMediaResult.removeEventListener("change", change);
      window.removeEventListener("keydown", esc);
    };
  }, []);
  useEffect(() => {
    if (pageData.houses) {
      setHouses(pageData.houses);
    }
    if (pageData.gruposAcesso) {
      setGruposAcesso(pageData.gruposAcesso);
    }
    if (pageData.teachers) {
      setTeachers(pageData.teachers);
    }
    if (pageData.activities) {
      setActivities(pageData.activities);
    }
    if (pageData.students) {
      setStudents(pageData.students);
    }
    if (pageData.checkpoints) {
      setCheckpoints(pageData.checkpoints);
    }
    if (pageData.redemptions) {
      setRedemptions(pageData.redemptions);
    }
    if (pageData.bonusLog) {
      setBonusLog(pageData.bonusLog);
    }
    if (pageData.batalhas) {
      setBatalhas(pageData.batalhas);
    }
    if (pageData.transfers) {
      setTransfers(pageData.transfers);
    }
    if (pageData.salas) {
      setSalas(pageData.salas);
    }
    if (pageData.agendamentos) {
      setAgendamentos(pageData.agendamentos);
    }
    if (pageData.bloqueios) {
      setBloqueios(pageData.bloqueios);
    }
    if (pageData.cardapio) {
      setCardapio(pageData.cardapio);
    }
    if (pageData.meritos) {
      setMeritos(pageData.meritos);
    }
  }, [pageData]);
  useEffect(() => {
    if (flash) {
      const timer = setTimeout(() => setFlash(null), 3500);
      return () => clearTimeout(timer);
    }
  }, [flash]);
  const currentStudent = useMemo(() => {
    const studentRecord = students.find((student) => student.id === studentId);
    if (!studentRecord) return authStudent ?? null;
    if (Number(authStudent?.id) !== Number(studentRecord.id)) return studentRecord;
    // O cadastro atualizado não contém a credencial da sessão. Preservá-la
    // somente para o mesmo aluno evita perder o acesso às tarefas após o perfil.
    return { ...studentRecord, learning_token: authStudent.learning_token };
  }, [students, studentId, authStudent]);
  const useSimuladoresConteudoStateResult = useSimuladoresConteudoState({
    adminLogged,
    currentStudent,
    view,
    adminAba,
  });
  const simuladoresConteudo =
    useSimuladoresConteudoStateResult.simuladoresConteudo;
  const setSimuladoresConteudo =
    useSimuladoresConteudoStateResult.setSimuladoresConteudo;
  const simuladoresConteudoNavigationTarget =
    useSimuladoresConteudoStateResult.simuladoresConteudoNavigationTarget;
  const setSimuladoresConteudoNavigationTarget =
    useSimuladoresConteudoStateResult.setSimuladoresConteudoNavigationTarget;
  const addSimuladorCategoria =
    useSimuladoresConteudoStateResult.addSimuladorCategoria;
  const updateSimuladorCategoria =
    useSimuladoresConteudoStateResult.updateSimuladorCategoria;
  const removeSimuladorCategoria =
    useSimuladoresConteudoStateResult.removeSimuladorCategoria;
  const restoreSimuladorCategoria =
    useSimuladoresConteudoStateResult.restoreSimuladorCategoria;
  const addSimuladorCurso = useSimuladoresConteudoStateResult.addSimuladorCurso;
  const updateSimuladorCurso =
    useSimuladoresConteudoStateResult.updateSimuladorCurso;
  const removeSimuladorCurso =
    useSimuladoresConteudoStateResult.removeSimuladorCurso;
  const restoreSimuladorCurso =
    useSimuladoresConteudoStateResult.restoreSimuladorCurso;
  const addSimuladorModulo =
    useSimuladoresConteudoStateResult.addSimuladorModulo;
  const updateSimuladorModulo =
    useSimuladoresConteudoStateResult.updateSimuladorModulo;
  const removeSimuladorModulo =
    useSimuladoresConteudoStateResult.removeSimuladorModulo;
  const restoreSimuladorModulo =
    useSimuladoresConteudoStateResult.restoreSimuladorModulo;
  const addSimuladorAula = useSimuladoresConteudoStateResult.addSimuladorAula;
  const updateSimuladorAula =
    useSimuladoresConteudoStateResult.updateSimuladorAula;
  const removeSimuladorAula =
    useSimuladoresConteudoStateResult.removeSimuladorAula;
  const restoreSimuladorAula =
    useSimuladoresConteudoStateResult.restoreSimuladorAula;
  const useOlimpiadaConteudoStateResult = useOlimpiadaConteudoState({
    adminLogged,
    currentStudent,
    view,
    adminAba,
  });
  const olimpiadaConteudo = useOlimpiadaConteudoStateResult.olimpiadaConteudo;
  const setOlimpiadaConteudo =
    useOlimpiadaConteudoStateResult.setOlimpiadaConteudo;
  const olimpiadaConteudoNavigationTarget =
    useOlimpiadaConteudoStateResult.olimpiadaConteudoNavigationTarget;
  const setOlimpiadaConteudoNavigationTarget =
    useOlimpiadaConteudoStateResult.setOlimpiadaConteudoNavigationTarget;
  const addOlimpiadaCategoria =
    useOlimpiadaConteudoStateResult.addOlimpiadaCategoria;
  const updateOlimpiadaCategoria =
    useOlimpiadaConteudoStateResult.updateOlimpiadaCategoria;
  const removeOlimpiadaCategoria =
    useOlimpiadaConteudoStateResult.removeOlimpiadaCategoria;
  const restoreOlimpiadaCategoria =
    useOlimpiadaConteudoStateResult.restoreOlimpiadaCategoria;
  const addOlimpiadaCurso = useOlimpiadaConteudoStateResult.addOlimpiadaCurso;
  const updateOlimpiadaCurso =
    useOlimpiadaConteudoStateResult.updateOlimpiadaCurso;
  const removeOlimpiadaCurso =
    useOlimpiadaConteudoStateResult.removeOlimpiadaCurso;
  const restoreOlimpiadaCurso =
    useOlimpiadaConteudoStateResult.restoreOlimpiadaCurso;
  const addOlimpiadaModulo = useOlimpiadaConteudoStateResult.addOlimpiadaModulo;
  const updateOlimpiadaModulo =
    useOlimpiadaConteudoStateResult.updateOlimpiadaModulo;
  const removeOlimpiadaModulo =
    useOlimpiadaConteudoStateResult.removeOlimpiadaModulo;
  const restoreOlimpiadaModulo =
    useOlimpiadaConteudoStateResult.restoreOlimpiadaModulo;
  const addOlimpiadaAula = useOlimpiadaConteudoStateResult.addOlimpiadaAula;
  const updateOlimpiadaAula =
    useOlimpiadaConteudoStateResult.updateOlimpiadaAula;
  const removeOlimpiadaAula =
    useOlimpiadaConteudoStateResult.removeOlimpiadaAula;
  const restoreOlimpiadaAula =
    useOlimpiadaConteudoStateResult.restoreOlimpiadaAula;
  const conteudosSessionKey = adminLogged
    ? "admin"
    : null !== authStudent && undefined !== authStudent && authStudent.id
      ? "student:".concat(authStudent.id)
      : "public";
  useEffect(() => {
    if (!isAuthenticated) {
      conteudosApiInitializedRef.current = false;
      conteudosBootstrapRef.current = false;
      previousConteudosRef.current = EMPTY_CONTEUDOS;
      skipConteudosSyncRef.current = true;
      conteudosLoadedRef.current = true;
      setConteudosRaw(EMPTY_CONTEUDOS);
      return;
    }
    if (adminLogged) return;
    let active = true;
    loadAlunoSnapshot()
      .then((result) => {
        let initialized = result.initialized;
        let nextSnapshot = result.nextSnapshot;
        if (active) {
          conteudosApiInitializedRef.current = initialized;
          previousConteudosRef.current = nextSnapshot;
          skipConteudosSyncRef.current = true;
          setConteudosRaw(nextSnapshot);
          conteudosEnterRefreshRef.current = "".concat(
            conteudosSessionKey,
            ":conteudos:relatorio",
          );
        }
      })
      .catch(() => {
        if (active) {
          previousConteudosRef.current = initialConteudos;
          skipConteudosSyncRef.current = true;
          setConteudosRaw(initialConteudos);
        }
      })
      .finally(() => {
        if (active) {
          conteudosLoadedRef.current = true;
        }
      });
    return () => {
      active = false;
    };
  }, [
    adminLogged,
    initialConteudos,
    conteudosSessionKey,
    isAuthenticated,
    loadAlunoSnapshot,
  ]);
  useEffect(() => {
    if (!conteudosLoadedRef.current) return;
    if (
      (conteudos?.categorias?.length || 0) > 0 ||
      (conteudos?.cursos?.length || 0) > 0 ||
      (conteudos?.modulos?.length || 0) > 0 ||
      (conteudos?.aulas?.length || 0) > 0
    ) {
      persistConteudosData(conteudos);
    }
  }, [conteudos]);
  useEffect(() => {
    if (!adminLogged || !conteudosLoadedRef.current) return;
    if (conteudosApiInitializedRef.current || conteudosBootstrapRef.current)
      return;
    if (
      !Boolean(
        conteudos?.categorias?.length ||
          conteudos?.cursos?.length ||
          conteudos?.modulos?.length ||
          conteudos?.aulas?.length,
      )
    )
      return;
    let active = true;
    conteudosBootstrapRef.current = true;
    Promise.all([
      saveConteudosStructure(conteudos),
      saveConteudosErrors(conteudos?.erros || []),
    ])
      .then(() => {
        if (active) {
          conteudosApiInitializedRef.current = true;
          previousConteudosRef.current = conteudos;
        }
      })
      .catch(() => {
        if (active) {
          conteudosBootstrapRef.current = false;
        }
      });
    return () => {
      active = false;
    };
  }, [adminLogged, conteudos]);
  useEffect(() => {
    const emConteudosAluno = "conteudos" === view;
    const emConteudosAdmin = "admin" === view && "conteudos-adm" === adminAba;
    if (!isAuthenticated || !(emConteudosAluno || emConteudosAdmin)) {
      conteudosEnterRefreshRef.current = "";
      return;
    }
    const chaveEntrada = ""
      .concat(conteudosSessionKey, ":")
      .concat(view, ":")
      .concat(adminAba);
    if (conteudosEnterRefreshRef.current === chaveEntrada) return;
    conteudosEnterRefreshRef.current = chaveEntrada;
    let active = true;
    if (emConteudosAdmin)
      return () => {
        active = false;
      };
    const prevSnap = previousConteudosRef.current;
    const jaTemDados = Boolean(
      conteudosLoadedRef.current &&
        (prevSnap?.categorias?.length || prevSnap?.cursos?.length),
    );
    if (!(emConteudosAluno && jaTemDados)) {
      loadAlunoSnapshot()
        .then((result) => {
          let initialized = result.initialized;
          let nextSnapshot = result.nextSnapshot;
          if (active) {
            conteudosApiInitializedRef.current = initialized;
            skipConteudosSyncRef.current = true;
            previousConteudosRef.current = nextSnapshot;
            setConteudosRaw(nextSnapshot);
          }
        })
        .catch(() => {});
    }
    return () => {
      active = false;
    };
  }, [adminAba, conteudosSessionKey, isAuthenticated, loadAlunoSnapshot, view]);
  useEffect(() => {
    if (!conteudosLoadedRef.current) return;
    if (skipConteudosSyncRef.current) {
      skipConteudosSyncRef.current = false;
      previousConteudosRef.current = conteudos;
      return;
    }
    const previousConteudos = previousConteudosRef.current;
    const studentKey =
      undefined !== currentStudent?.id && null !== currentStudent?.id
        ? String(currentStudent.id)
        : null;
    window.clearTimeout(conteudosSyncTimerRef.current);
    conteudosSyncTimerRef.current = window.setTimeout(async () => {
      try {
        if (adminLogged) {
          const tasks = [];
          if (
            serialize(pickConteudosStructure(previousConteudos)) !==
            serialize(pickConteudosStructure(conteudos))
          ) {
            tasks.push(saveConteudosStructure(conteudos));
          }
          if (
            serialize(previousConteudos?.erros || []) !==
            serialize(conteudos?.erros || [])
          ) {
            tasks.push(saveConteudosErrors(conteudos?.erros || []));
          }
          if (tasks.length) {
            await Promise.all(tasks);
            conteudosApiInitializedRef.current = true;
          }
        } else if (studentKey && conteudosApiInitializedRef.current) {
          const previousProgress =
            previousConteudos?.progresso?.[studentKey] || {};
          const nextProgress = conteudos?.progresso?.[studentKey] || {};
          if (serialize(previousProgress) !== serialize(nextProgress)) {
            await saveConteudosProgress(nextProgress);
          }
        }
        previousConteudosRef.current = conteudos;
      } catch (error) {}
    }, 500);
    return () => {
      window.clearTimeout(conteudosSyncTimerRef.current);
    };
  }, [adminLogged, conteudos, currentStudent?.id]);
  const addConteudoCategoria = useCallback(async (payload) => {
    const categoria = await createConteudoCategoria(payload);
    if (!categoria) throw new Error("Falha ao criar categoria");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        categorias: [...(prev.categorias || []), categoria],
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return categoria;
  }, []);
  const updateConteudoCategoriaState = useCallback(
    async (categoriaId, payload) => {
      const categoria = await updateConteudoCategoria(categoriaId, payload);
      if (!categoria) throw new Error("Falha ao atualizar categoria");
      setConteudosRaw((prev) => {
        const nextValue = {
          ...prev,
          categorias: (prev.categorias || []).map((item) =>
            item.id === categoriaId ? categoria : item,
          ),
        };
        previousConteudosRef.current = nextValue;
        return nextValue;
      });
      return categoria;
    },
    [],
  );
  const removeConteudoCategoria = useCallback(async (categoriaId) => {
    await deleteConteudoCategoria(categoriaId);
    setConteudosRaw((prev) => {
      const cursosIds = (prev.cursos || [])
        .filter((item) => item.cat_id === categoriaId)
        .map((item) => item.id);
      const modulosIds = (prev.modulos || [])
        .filter((item) => cursosIds.includes(item.curso_id))
        .map((item) => item.id);
      const aulasIds = (prev.aulas || [])
        .filter((item) => modulosIds.includes(item.modulo_id))
        .map((item) => item.id);
      const nextValue = {
        ...prev,
        categorias: (prev.categorias || []).filter(
          (item) => item.id !== categoriaId,
        ),
        cursos: (prev.cursos || []).filter(
          (item) => item.cat_id !== categoriaId,
        ),
        modulos: (prev.modulos || []).filter(
          (item) => !cursosIds.includes(item.curso_id),
        ),
        aulas: (prev.aulas || []).filter(
          (item) => !modulosIds.includes(item.modulo_id),
        ),
        progresso: Object.keys(prev.progresso || {}).reduce(
          (acc, studentKey) => {
            const currentProgress = {
              ...(prev.progresso?.[studentKey] || {}),
            };
            aulasIds.forEach((aulaId) => delete currentProgress[aulaId]);
            acc[studentKey] = currentProgress;
            return acc;
          },
          {},
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
  }, []);
  const restoreConteudoCategoriaState = useCallback(async (categoriaId) => {
    await restoreConteudoCategoria(categoriaId);
    const snapshot = (await fetchConteudosState()).snapshot;
    const normalized = normalizeConteudosData(snapshot);
    skipConteudosSyncRef.current = true;
    previousConteudosRef.current = normalized;
    setConteudosRaw(normalized);
  }, []);
  const addConteudoCurso = useCallback(async (payload) => {
    const curso = await createConteudoCurso(payload);
    if (!curso) throw new Error("Falha ao criar curso");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        cursos: [...(prev.cursos || []), curso],
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return curso;
  }, []);
  const updateConteudoCursoState = useCallback(async (cursoId, payload) => {
    const curso = await updateConteudoCurso(cursoId, payload);
    if (!curso) throw new Error("Falha ao atualizar curso");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        cursos: (prev.cursos || []).map((item) =>
          item.id === cursoId ? curso : item,
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return curso;
  }, []);
  const removeConteudoCurso = useCallback(async (cursoId) => {
    await deleteConteudoCurso(cursoId);
    setConteudosRaw((prev) => {
      const modulosIds = (prev.modulos || [])
        .filter((item) => item.curso_id === cursoId)
        .map((item) => item.id);
      const aulasIds = (prev.aulas || [])
        .filter((item) => modulosIds.includes(item.modulo_id))
        .map((item) => item.id);
      const nextValue = {
        ...prev,
        cursos: (prev.cursos || []).filter((item) => item.id !== cursoId),
        modulos: (prev.modulos || []).filter(
          (item) => item.curso_id !== cursoId,
        ),
        aulas: (prev.aulas || []).filter(
          (item) => !modulosIds.includes(item.modulo_id),
        ),
        progresso: Object.keys(prev.progresso || {}).reduce(
          (acc, studentKey) => {
            const currentProgress = {
              ...(prev.progresso?.[studentKey] || {}),
            };
            aulasIds.forEach((aulaId) => delete currentProgress[aulaId]);
            acc[studentKey] = currentProgress;
            return acc;
          },
          {},
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
  }, []);
  const restoreConteudoCursoState = useCallback(async (cursoId) => {
    await restoreConteudoCurso(cursoId);
    const snapshot = (await fetchConteudosState()).snapshot;
    const normalized = normalizeConteudosData(snapshot);
    skipConteudosSyncRef.current = true;
    previousConteudosRef.current = normalized;
    setConteudosRaw(normalized);
  }, []);
  const addConteudoModulo = useCallback(async (payload) => {
    const modulo = await createConteudoModulo(payload);
    if (!modulo) throw new Error("Falha ao criar modulo");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        modulos: [...(prev.modulos || []), modulo],
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return modulo;
  }, []);
  const updateConteudoModuloState = useCallback(async (moduloId, payload) => {
    const modulo = await updateConteudoModulo(moduloId, payload);
    if (!modulo) throw new Error("Falha ao atualizar modulo");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        modulos: (prev.modulos || []).map((item) =>
          item.id === moduloId ? modulo : item,
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return modulo;
  }, []);
  const removeConteudoModulo = useCallback(async (moduloId) => {
    await deleteConteudoModulo(moduloId);
    setConteudosRaw((prev) => {
      const aulasIds = (prev.aulas || [])
        .filter((item) => item.modulo_id === moduloId)
        .map((item) => item.id);
      const nextValue = {
        ...prev,
        modulos: (prev.modulos || []).filter((item) => item.id !== moduloId),
        aulas: (prev.aulas || []).filter((item) => item.modulo_id !== moduloId),
        progresso: Object.keys(prev.progresso || {}).reduce(
          (acc, studentKey) => {
            const currentProgress = {
              ...(prev.progresso?.[studentKey] || {}),
            };
            aulasIds.forEach((aulaId) => delete currentProgress[aulaId]);
            acc[studentKey] = currentProgress;
            return acc;
          },
          {},
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
  }, []);
  const restoreConteudoModuloState = useCallback(async (moduloId, payload = {}) => {
    await restoreConteudoModulo(moduloId, payload);
    const { snapshot } = await fetchConteudosState();
    const normalized = normalizeConteudosData(snapshot);
    skipConteudosSyncRef.current = true;
    previousConteudosRef.current = normalized;
    setConteudosRaw(normalized);
  }, []);
  const addConteudoAula = useCallback(async (payload) => {
    const aula = await createConteudoAula(payload);
    if (!aula) throw new Error("Falha ao criar aula");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        aulas: [...(prev.aulas || []), aula],
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return aula;
  }, []);
  const updateConteudoAulaState = useCallback(async (aulaId, payload) => {
    const aula = await updateConteudoAula(aulaId, payload);
    if (!aula) throw new Error("Falha ao atualizar aula");
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        aulas: (prev.aulas || []).map((item) =>
          item.id === aulaId ? aula : item,
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
    return aula;
  }, []);
  const removeConteudoAula = useCallback(async (aulaId) => {
    await deleteConteudoAula(aulaId);
    setConteudosRaw((prev) => {
      const nextValue = {
        ...prev,
        aulas: (prev.aulas || []).filter((item) => item.id !== aulaId),
        progresso: Object.keys(prev.progresso || {}).reduce(
          (acc, studentKey) => {
            const currentProgress = {
              ...(prev.progresso?.[studentKey] || {}),
            };
            delete currentProgress[aulaId];
            acc[studentKey] = currentProgress;
            return acc;
          },
          {},
        ),
      };
      previousConteudosRef.current = nextValue;
      return nextValue;
    });
  }, []);
  const restoreConteudoAulaState = useCallback(async (aulaId, payload = {}) => {
    await restoreConteudoAula(aulaId, payload);
    const { snapshot } = await fetchConteudosState();
    const normalized = normalizeConteudosData(snapshot);
    skipConteudosSyncRef.current = true;
    previousConteudosRef.current = normalized;
    setConteudosRaw(normalized);
  }, []);
  const setConteudos = useCallback((nextValue) => {
    setConteudosRaw((prev) =>
      "function" === typeof nextValue ? nextValue(prev) : nextValue,
    );
  }, []);
  useEffect(() => {
    if (
      null !== authStudent &&
      undefined !== authStudent &&
      authStudent.id &&
      authStudent.id !== studentId
    ) {
      setStudentId(authStudent.id);
    }
  }, [authStudent, studentId]);
  const getPontosRank = useCallback(
    (alunoId) =>
      addRankingPoints(
        checkpointsComAutomaticos
          .filter(
            (checkpointsComAutomatico) =>
              Number(checkpointsComAutomatico.aluno_id) === Number(alunoId) &&
              "invalido" !== checkpointsComAutomatico.status_questao,
          )
          .reduce(
            (accumulator, item) =>
              addRankingPoints(accumulator, +item.pontos_rank || 0),
            0,
          ),
        taskBonusTotals.points[Number(alunoId)] || 0,
      ),
    [checkpointsComAutomaticos, taskBonusTotals.points],
  );
  const getTokensGanhos = useCallback(
    (alunoId) =>
      checkpointsComAutomaticos
        .filter(
          (checkpointsComAutomatico) =>
            Number(checkpointsComAutomatico.aluno_id) === Number(alunoId) &&
            "invalido" !== checkpointsComAutomatico.status_questao,
        )
        .reduce((accumulator, item) => accumulator + (+item.tokens || 0), 0) +
      bonusLog
        .filter(
          (bonusLogAluno_id) =>
            Number(bonusLogAluno_id.aluno_id) === Number(alunoId),
        )
        .reduce((accumulator, item) => accumulator + (+item.tokens || 0), 0) +
      transfers
        .filter((transfer) => Number(transfer.para) === Number(alunoId))
        .reduce((accumulator, item) => accumulator + (+item.tokens || 0), 0),
    [checkpointsComAutomaticos, bonusLog, transfers],
  );
  const getTokensDisponiveis = useCallback(
    (alunoId) =>
      getTokensGanhos(alunoId) -
      redemptions
        .filter(
          (redemption) =>
            Number(redemption.aluno_id) === Number(alunoId) &&
            "cancelado" !== redemption.status,
        )
        .reduce((accumulator, item) => accumulator + (+item.pontos || 0), 0) -
      transfers
        .filter((transfer) => Number(transfer.de) === Number(alunoId))
        .reduce((accumulator, item) => accumulator + (+item.tokens || 0), 0) -
      batalhas
        .filter(
          (batalha) =>
            "finalizada" === batalha.status &&
            Number(batalha.perdedor_id) === Number(alunoId),
        )
        .reduce((accumulator, item) => accumulator + (+item.aposta || 0), 0) +
      batalhas
        .filter(
          (batalha) =>
            "finalizada" === batalha.status &&
            Number(batalha.vencedor_id) === Number(alunoId),
        )
        .reduce((accumulator, item) => accumulator + (+item.aposta || 0), 0),
    [getTokensGanhos, redemptions, transfers, batalhas],
  );
  const showFlash = (msg, tipo = "ok") => setFlash({ msg, tipo });
  const goto = (nextView, options = {}) => {
    if (nextView === view) {
      setPageResetKeys((previous) => ({
        ...previous,
        [nextView]: (previous[nextView] || 0) + 1,
      }));
    }
    gotoView(nextView);
    if (!options.keepViewing) setViewingStudent(null);
    setEditingProfile(false);
    if (!options.keepEditing) {
      setEditingStudent(null);
      setEditingHouse(null);
      setEditingTeacher(null);
      setEditingActivity(null);
      setEditingGrupoAcesso(null);
    }
    window.scrollTo(0, 0);
  };
  const goBack = () => {
    if (goBackView()) {
      setViewingStudent(null);
      setEditingProfile(false);
      window.scrollTo(0, 0);
    }
  };
  const logout = useCallback(() => {
    const isAluno = !!authStudent || (!!studentId && !adminLogged);
    authLogout();
    globalCacheRef.data = {};
    globalCacheRef.invalidated.clear();
    setStudentId(null);
    setViewingStudent(null);
    setEditingProfile(false);
    setSideOpen(false);
    gotoView(isAluno ? "login-aluno" : "login-admin");
    window.scrollTo(0, 0);
  }, [authStudent, studentId, adminLogged, authLogout, gotoView]);
  const ctx = {
    houses,
    gruposAcesso,
    teachers,
    activities,
    students,
    checkpoints: checkpointsCompletos,
    checkpointsComAutomaticos,
    redemptions,
    bonusLog,
    batalhas,
    transfers,
    salas,
    agendamentos,
    bloqueios,
    cardapio,
    meritos,
    conteudos,
    conteudosNavigationTarget,
    pageLoading,
    currentStudent,
    setHouses,
    setGruposAcesso,
    setTeachers,
    setActivities,
    setStudents,
    setCheckpoints,
    setRedemptions,
    setBonusLog,
    setBatalhas,
    setTransfers,
    setSalas,
    setAgendamentos,
    setBloqueios,
    setCardapio,
    setMeritos,
    setConteudos,
    addConteudoCategoria,
    updateConteudoCategoria: updateConteudoCategoriaState,
    addConteudoCurso,
    updateConteudoCurso: updateConteudoCursoState,
    removeConteudoCurso,
    addConteudoModulo,
    updateConteudoModulo: updateConteudoModuloState,
    removeConteudoModulo,
    addConteudoAula,
    updateConteudoAula: updateConteudoAulaState,
    removeConteudoAula,
    restoreConteudoAula: restoreConteudoAulaState,
    removeConteudoCategoria,
    restoreConteudoCategoria: restoreConteudoCategoriaState,
    restoreConteudoCurso: restoreConteudoCursoState,
    restoreConteudoModulo: restoreConteudoModuloState,
    setConteudosNavigationTarget,
    simuladoresConteudo,
    setSimuladoresConteudo,
    simuladoresConteudoNavigationTarget,
    setSimuladoresConteudoNavigationTarget,
    addSimuladorCategoria,
    updateSimuladorCategoria,
    removeSimuladorCategoria,
    restoreSimuladorCategoria,
    addSimuladorCurso,
    updateSimuladorCurso,
    removeSimuladorCurso,
    restoreSimuladorCurso,
    addSimuladorModulo,
    updateSimuladorModulo,
    removeSimuladorModulo,
    restoreSimuladorModulo,
    addSimuladorAula,
    updateSimuladorAula,
    removeSimuladorAula,
    restoreSimuladorAula,
    olimpiadaConteudo,
    setOlimpiadaConteudo,
    olimpiadaConteudoNavigationTarget,
    setOlimpiadaConteudoNavigationTarget,
    addOlimpiadaCategoria,
    updateOlimpiadaCategoria,
    removeOlimpiadaCategoria,
    restoreOlimpiadaCategoria,
    addOlimpiadaCurso,
    updateOlimpiadaCurso,
    removeOlimpiadaCurso,
    restoreOlimpiadaCurso,
    addOlimpiadaModulo,
    updateOlimpiadaModulo,
    removeOlimpiadaModulo,
    restoreOlimpiadaModulo,
    addOlimpiadaAula,
    updateOlimpiadaAula,
    removeOlimpiadaAula,
    restoreOlimpiadaAula,
    showFlash,
    goto,
    goBack,
    verPerfil: (resultado) => {
      setViewingStudent(resultado);
      goto("perfil", {
        keepViewing: true,
      });
    },
    getPontosRank,
    getTokensGanhos,
    getTokensDisponiveis,
    editingStudent,
    setEditingStudent,
    editingHouse,
    setEditingHouse,
    editingTeacher,
    setEditingTeacher,
    editingActivity,
    setEditingActivity,
    editingGrupoAcesso,
    setEditingGrupoAcesso,
    viewingStudent,
    setViewingStudent,
    editingProfile,
    setEditingProfile,
    studentId,
    setStudentId,
    pageResetKeys,
    adminLogged,
    setAdminLogged,
    adminAba,
    setAdminAba,
    loginAluno,
    loginAdmin,
    logout,
    authLoading,
    authError,
    setAuthError,
  };
  const questPend = checkpointsCompletos.filter(
    (checkpointsCompleto) => "pendente" === checkpointsCompleto.status_questao,
  ).length;
  const resgPend = redemptions.filter(
    (redemption) => "pendente" === redemption.status,
  ).length;
  const desPend = batalhas.filter(
    (batalha) =>
      "aguardando" === batalha.status && batalha.desafiado_id === studentId,
  ).length;
  const agPendHoje = agendamentos.filter(
    (agendamento) =>
      agendamento.data === todayISO() && "confirmado" === agendamento.status,
  ).length;
  return {
    adminAba,
    adminLogged,
    agPendHoje,
    agendamentos,
    canGoBack,
    ctx,
    currentStudent,
    desPend,
    flash,
    goBack,
    goto,
    logado: !(!currentStudent && !adminLogged),
    pageResetKeys,
    questPend,
    resgPend,
    setAdminAba,
    setSideOpen,
    sideOpen,
    view,
  };
}
